const ValidationStatus = {
    Success: 'Success',
    Warning: 'Warning',
    Error: 'Error',
    Info: 'Info'
};

export default ValidationStatus;
